(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fcr-seo-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {

    document.querySelectorAll('.fcr-seo-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var contentId = trigger.getAttribute('aria-controls');
        var content   = document.getElementById(contentId);
        if (!content) return;
        fcrToggle(trigger, content);
      });
    });

    document.querySelectorAll('.fcr-faq__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var answerId = trigger.getAttribute('aria-controls');
        var answer   = document.getElementById(answerId);
        if (!answer) return;
        fcrToggle(trigger, answer);
      });
    });

    function fcrToggle(trigger, panel) {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        panel.style.height     = panel.scrollHeight + 'px';
        panel.style.overflow   = 'hidden';
        panel.style.transition = 'height 0.32s ease';
        panel.classList.add('is-animating');
        requestAnimationFrame(function () { panel.style.height = '0'; });
        panel.addEventListener('transitionend', function close() {
          panel.setAttribute('hidden', '');
          panel.style.cssText = '';
          panel.classList.remove('is-animating');
          panel.removeEventListener('transitionend', close);
        });
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        panel.removeAttribute('hidden');
        panel.classList.add('is-animating');
        panel.style.height     = '0';
        panel.style.overflow   = 'hidden';
        panel.style.transition = 'height 0.32s ease';
        requestAnimationFrame(function () {
          panel.style.height = panel.scrollHeight + 'px';
        });
        panel.addEventListener('transitionend', function open() {
          panel.style.cssText = '';
          panel.classList.remove('is-animating');
          panel.removeEventListener('transitionend', open);
        });
        trigger.setAttribute('aria-expanded', 'true');
      }
    }

  })();

  } catch(e) { console.error(e); }
})();
})();
